import React from 'react';
import { useAuthSync } from '../hooks/useAuthSync';
import CookieConsentBanner from './CookieConsentBanner';

interface AppShellProps {
  children: React.ReactNode;
}

/**
 * AppShell is a simple wrapper component that renders children.
 * Consent is now handled locally in SessionEntryPage and signup flows only.
 */
export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  // Listen for real-time auth changes (e.g., role promoted by superadmin)
  useAuthSync();
  return (
    <>
      {children}
      <CookieConsentBanner />
    </>
  );
};

export default AppShell;
